import Vue from 'vue';
import Hero from '@/components/Hero';
import SectionTitle from '@/components/SectionTitle';
import Tag from '@/components/Tag';
import Card from '@/components/Card';
import App from '@/App';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import '@/icons'

import (/* webpackChunkName: "critical", webpackPreload: true */ './scss/critical.css');
import './scss/index.scss'

import router from './router';

Vue.component('hero', Hero);
Vue.component('section-title', SectionTitle);
Vue.component('tag', Tag);
Vue.component('card', Card);
Vue.component('fa-icon', FontAwesomeIcon)

/*new Vue({
    el: '#app',
    components: {
        Typewriter
    }
});
*/
const root = new Vue({
    router,
    render: h => h(App),
    data() {
        return {
            available: false,
            contact: {
                name: 'Michael Feinbier',
                email: 'info@feinbier.net',
                street: 'Erik-Nölting-Str. 10',
                zip: '40227',
                city: 'Düsseldorf',
                phone: ' 0160 / 94 64 11 23',
                phonelink: 'tel:+4916094641123',
                ustid: 'DE297829369'
          }
        }
    },
}).$mount('#app');

let didScroll = false,
    lastScrollTop = 0;

$(window).on('scroll', () => didScroll = true);
setInterval(() => {
    if (didScroll) { root.$emit('scroll', $(window).scrollTop()); didScroll = false;}
}, 125);
